module.exports = __webpack_public_path__ + "ptc_nakagawa_H1.de42a54a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_H1.jpg
// module id = FO0W
// module chunks = 0